import "../item.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.Wizard ??= {};
window.AppointmentBooking.Wizard.Views ??= {};
window.AppointmentBooking.Wizard.Views.Header ??= {};
window.AppointmentBooking.Wizard.Views.Header.MainMenu ??= {};

AppointmentBooking.Wizard.Views.Header.MainMenu.AppointmentSlotItem = class AppointmentSlotItem extends (
  AppointmentBooking.Wizard.Views.Header.MainMenu.Item
) {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
  }

  initialize() {
    super.initialize(...arguments);
    return this.listenTo(this.booking, "change:visit_type_chosen", this.render);
  }
};
AppointmentBooking.Wizard.Views.Header.MainMenu.AppointmentSlotItem.prototype.template =
  "header/main_menu/item/appointment_slot";
AppointmentBooking.Wizard.Views.Header.MainMenu.AppointmentSlotItem.prototype.className =
  "appointment-booking-wizard-main-menu-appointment-slot-item";
